import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "../../context/authContext";
import {
    HiOutlineChevronDown,
    HiOutlineLogout,
} from "react-icons/hi";

const NavBarMenu = () => {
    const { signOut, userData } = useAuth();
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleSignOut = (e) => {
        e.preventDefault();
        signOut();
    };

    // закрытие дропдауна по клику вне
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <header className="h-16 bg-admin-surface border-b border-admin-line flex items-center px-6">
            <div className="flex items-center justify-end w-full gap-4">

                {/* USER DROPDOWN */}
                <div className="relative" ref={dropdownRef}>
                    <button
                        onClick={() => setOpen(!open)}
                        className="
                            flex items-center gap-2 px-3 py-1.5
                            rounded-full hover:bg-admin-soft transition
                        "
                    >
                        <div className="w-8 h-8 rounded-full bg-admin-soft flex items-center justify-center flex-shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-admin-muted" viewBox="0 0 24 24" fill="currentColor">
                                <path fillRule="evenodd" d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z" clipRule="evenodd" />
                            </svg>
                        </div>
                        <div className="text-left hidden sm:block">
                            <p className="text-sm font-medium text-admin-heading leading-tight">
                                {userData?.name?.trim() ? userData.name : "N/A"}
                            </p>
                            <p className="text-xs text-admin-muted">
                                {userData?.role}
                            </p>
                        </div>
                        <HiOutlineChevronDown className="w-4 h-4 text-admin-muted" />
                    </button>

                    {open && (
                        <div className="absolute right-0 mt-2 w-56 bg-admin-surface border border-admin-line rounded-xl shadow-lg overflow-hidden z-50">

                            <button
                                onClick={handleSignOut}
                                className="
                                    w-full flex items-center gap-3 px-4 py-3
                                    text-admin-danger hover:bg-admin-danger/20 transition
                                "
                            >
                                <HiOutlineLogout className="w-5 h-5" />
                                <span className="text-sm font-medium">
                                    Logout
                                </span>
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

export default NavBarMenu;
